import consumer from "./consumer";

document.addEventListener("DOMContentLoaded", () => {
  const chatContainer = document.getElementById("messages");
  const form = document.getElementById("message-form");
  const input = document.getElementById("message-input");
  const recipeId = chatContainer?.dataset.recipeId;
  const currentUserId = chatContainer?.dataset.userId;
  const currentUserName = chatContainer?.dataset.userName; // Правильний доступ до userName
  const currentUserType = document.getElementById("messages")?.dataset.userType;

  if (!chatContainer || !recipeId || !currentUserId || !currentUserName) {
    console.warn("⚠️ Дані користувача або рецепта не визначені.");
    return;
  }

  console.log("✅ WebSocket ініціалізація...");
  // const socket = new WebSocket("ws://localhost:3000/cable");

  const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";
  const host = window.location.host; // 🔹 Отримує домен (з портом, якщо є)
  const path = "/cable"; // 🔹 Шлях до WebSocket

  const socket = new WebSocket(`${protocol}${host}${path}`);

  const markMessagesAsRead = () => {
    console.log("📡 Відправка запиту на позначення прочитаних...");

    fetch(`/cabinet/messages/mark_read?recipe_id=${recipeId}`, { method: "POST" })
      .then(response => {
        if (response.ok) {
          console.log("✅ Запит пройшов успішно!");
        } else {
          console.error("❌ Помилка: Запит не виконаний!");
        }
      })
      .catch(error => console.error("🚨 Виникла помилка:", error));
  };

  // Додаємо виклик `markMessagesAsRead()` при відкритті чату
  document.getElementById("chat-icon").addEventListener("click", () => {
    scrollToBottom(); // 🔹 Автоматичне прокручування вниз
    markMessagesAsRead();
  });

  socket.onopen = () => console.log("✅ WebSocket підключено!");
  socket.onerror = (error) => console.error("❌ Помилка WebSocket", error);

  const scrollToBottom = () => {
    chatContainer.scrollTop = chatContainer.scrollHeight;
  };

  const chatSubscription = consumer.subscriptions.create(
    { channel: "Cabinet::RecipeChatChannel", recipe_id: recipeId },
    {
      connected() {
        console.log(`✅ Підключено до чату рецепта #${recipeId}`);
        console.log(`👤 Користувач: ${currentUserName}`);
        console.log(`🔍 Тип користувача: ${currentUserType}`);
      },
      disconnected() {
        console.warn(`⚠️ Відключено від чату рецепта #${recipeId}`);
      },
      received(data) {
        const senderName = data.sender || "Анонім";
        console.log(`📩 Отримано повідомлення від ${senderName}: ${data.content}`);

        const messageWrapper = document.createElement("div");
        messageWrapper.classList.add("message");

        const senderElement = document.createElement("p");
        senderElement.classList.add("message__name");
        senderElement.innerText = `${senderName}:`;

        const contentElement = document.createElement("p");
        contentElement.classList.add("message__content");
        contentElement.innerText = data.content;

        messageWrapper.appendChild(senderElement);
        messageWrapper.appendChild(contentElement);
        chatContainer.appendChild(messageWrapper);

        scrollToBottom(); // 🔹 Автоматичне прокручування вниз
      },
      rejected() {
        console.error(`❌ Не вдалося підключитися до чату рецепта #${recipeId}`);
      }
    }
  );

  // Відправка повідомлення через форму
  form?.addEventListener("submit", (event) => {
    event.preventDefault();
    const content = input.value.trim();
    if (!content) return;

    console.log(`✉️ Відправка повідомлення: ${content}`);

    chatSubscription.perform("receive", {
      recipe_id: recipeId,
      user_id: currentUserId,
      sender: currentUserName, // Передаємо правильне ім'я
      content: content
    });

    input.value = "";
    scrollToBottom(); // 🔹 Автоматичне прокручування вниз
  });
});

const updateChatIcon = () => {
  const chatIcon = document.getElementById("chat-icon");
  if (chatIcon) {
    // chatIcon.innerHTML = "💬"; // 🔹 Очищує вміст і вставляє новий символ
    chatIcon.innerHTML = '<i id="fa-message-grey" class="fa-solid fa-message"></i>';

  } else {
    console.warn("⚠️ Елемент #chat-icon не знайдено!");
  }
};

document.addEventListener("DOMContentLoaded", () => {
  const chatIcon = document.getElementById("chat-icon");

  // Перевіряємо URL: якщо є параметр `?open_chat=true`, відкриваємо чат
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get("open_chat") === "true") {
    setTimeout(() => {
      chatIcon.click();
      updateChatIcon();
    }, 500); // 🔹 Невелика затримка для коректного відкриття
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const chatIcon = document.getElementById("chat-icon");
  if (chatIcon) {
    chatIcon.addEventListener("click", updateChatIcon);
    console.log("✅ Обробник події успішно додано!");
  } else {
    console.warn("❌ Елемент #chat-icon не знайдено!");
  }
});